module.exports = __webpack_public_path__ + "img/linkedin.2c9d9ce.svg";